import React from "react"
import styled from "styled-components"
import IntercomWithAuth from "../Intercom/index.js"
import RaygunUser from "../Raygun/index.js"
import Routes from "./Routes.js"
import { AnalyticsWrapper as Analytics } from "../lib/Analytics/index.js"
import { withFeatureFlagProvider } from "../lib/feature-flags"
import { ImpersonationOverlay } from "../lib/auth"
import { ModalProvider } from "../components/Dashboard/JobSeekerDashboard/ModalContext"
import { SegmentWrapper as SegmentAnalytics } from "../lib/Segment/"
export const MainBox = styled.main`
  height: 80vh;
`

export const App = () => (
  <MainBox>
    <ModalProvider>
      <ImpersonationOverlay />
      <RaygunUser />
      <Analytics />
      <SegmentAnalytics />
      <Routes />
      <IntercomWithAuth />
    </ModalProvider>
  </MainBox>
)

export default withFeatureFlagProvider(App)
